import React, { useState, useEffect } from 'react';
import { useNavigate, useParams,useLocation } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Card, Form, Button, Collapse, Modal } from 'react-bootstrap';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import Sidebar from '../../../../../Components/Sidebar';
import Footer from '../../../../../Components/Footer';
import getEnvConfig from "../../../../../config";
import { setToken, fetchToken, RequireToken } from '../../../../../Auth';

const CheckoutForm = ({ chargerData }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = fetchToken();
    const { chargerid, portId } = useParams();
    const navigate = useNavigate();
  
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [clientSecret, setclientSecret] = useState(null);
    
    const { backendUrl } = getEnvConfig();
    const [taxOpen, setTaxOpen] = useState(false);
    const [showGuestPrompt, setShowGuestPrompt] = useState(!token);
    const [isGuest, setIsGuest] = useState(false);
    const location = useLocation();


  // Determine the actual charger ID - either from props, params, or a fallback
  const effectiveChargerId = chargerData?.charger_id || chargerid || null;
  const effectivePortId = chargerData?.port_id || portId || null;

  console.log('Charger ID:', effectiveChargerId);
  console.log('Port ID:', effectivePortId);

  // Guest prompt modal
  if (!token && !isGuest) {
    return (
      <Modal show centered>
        <Modal.Header>
          <Modal.Title>Sign In or Continue as Guest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You must be signed in to access session history and reporting. You can continue as a guest, but you will not have access to these features.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {
            navigate('/signin', { state: { from: location } })
          }}>
            Sign In / Sign Up
          </Button>
          <Button variant="secondary" onClick={() => { setIsGuest(true); setShowGuestPrompt(false); }}>Continue as Guest</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const createPaymentIntentOnBackend = async () => {
    try {
      // Prepare the payment intent request data
      const paymentData = {
        amount: 5000, // $50 hold
        currency: 'usd',
        charger_id: String(effectiveChargerId),
        port_id: String(effectivePortId),
      };
      if (token) paymentData.user_token = token;
      else paymentData.user_id = "-1";
      
      // If we have a port ID, include it in the request
      if (effectivePortId) {
        paymentData.port_id = String(effectivePortId);
      }
      
      const response = await axios.post(`${backendUrl}/chargers/create-payment-intent`, paymentData);
      return { clientSecret: response.data.clientSecret , transaction_id: response.data.transaction_id};
    } catch (error) {
      console.error('Error creating payment intent:', error);
      return { error: 'Error creating payment intent' };
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { error: backendError, clientSecret, transaction_id } = await createPaymentIntentOnBackend();

      if (backendError) {
        setError(backendError);
        setLoading(false);
        return;
      } else {
        setclientSecret(clientSecret);
        
      } 

      const cardElement = elements.getElement(CardElement);
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
        },
      });

      if (result.error) {
        console.log(result.error.message);
        setError(result.error.message);
      } else {
        if (result.paymentIntent.status === 'requires_capture') {
          console.log('Payment succeeded, charger can be turned on');

          const paymentIntentId = result.paymentIntent.id;
          try {
            // Prepare the data for starting the charging session
            const sessionData = {
              paymentIntentId: paymentIntentId,         
              portId: effectivePortId,
              clientSecret: clientSecret
            };
            if (token) sessionData.user_token = token;
            else sessionData.user_id = "-1";
            // If we have a port ID, include it
            if (effectivePortId) {
              sessionData.portId = effectivePortId;
            }

            console.log('sessionData', sessionData);
            
            await axios.post(`${backendUrl}/chargers/store-payment-intent`, sessionData);
            alert('Starting Charging Session');
            if (!isGuest) navigate('/users/drivers/driver-charging-history');
            else navigate('/');
          } catch (error) {
            console.error('Error storing payment intent:', error);
            alert('Payment Processing Error: ' + error);
          }
        }
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while processing the payment');
    }

    setLoading(false);
  };

  if (!chargerData) {
    return (
        <div style={{ display: 'flex' }}>
        <Sidebar />
        <Container fluid style={{ marginLeft: '200px' }}> {/* Adjust margin-left as needed */}
        <Row className="justify-content-center my-5">
                <Col md={8} lg={6}>
                    <Card className="p-4 shadow-sm">
                    <h4>Loading Charger Details...</h4>
                    </Card>
                </Col>
                </Row>
        </Container>
        </div>
    );
  }

  if (chargerData) {
    return (
      <Container fluid={true}>
        <Row className="justify-content-center my-5">
            <Col md={14} lg={10}>
                <Card className="p-4 shadow-sm">
                    <h4 className="mb-3">Charger Details</h4>
                    {chargerData.port_number && (
                      <p><strong>Port Number:</strong> {chargerData.port_number}</p>
                    )}
                    {chargerData.connector_type_name && (
                      <p><strong>Connector Type:</strong> {chargerData.connector_type_name}</p>
                    )}
                    {/*
                    {chargerData.max_power_kw && (
                      <p><strong>Max Power:</strong> {chargerData.max_power_kw} kW</p>
                    )}
                    */}
                    <p><strong>Base Price per kWh:</strong> ${chargerData.base_price ? chargerData.base_price.toFixed(2) : 'N/A'}</p>
                    
                    {chargerData.fixed_platform_fee !== undefined && (
                      <p><strong>Fixed Platform Fee / kWh:</strong> ${chargerData.fixed_platform_fee.toFixed(2)}</p>
                    )}
                    
                    <p><strong>Service Charge / kWh:</strong> ${chargerData.service_charge ? chargerData.service_charge.toFixed(2) : 'N/A'}</p>

                    {/* Collapsible Tax Amount Section */}
                    <p>
                        <strong>Tax Amount / kWh :</strong>
                        <Button
                            variant="link"
                            onClick={() => setTaxOpen(!taxOpen)}
                            aria-controls="tax-breakdown"
                            aria-expanded={taxOpen}
                            className="ml-2 p-0"
                        >
                            {chargerData.tax_amount ? `$${chargerData.tax_amount.toFixed(2)}` : 'N/A'}
                        </Button>
                    </p>
                    <Collapse in={taxOpen}>
                        <div id="tax-breakdown">
                            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                <li><strong>State Tax Rate:</strong> {chargerData.state_rate ? `${chargerData.state_rate}%` : 'N/A'}</li>
                                <li><strong>Special Tax Rate:</strong> {chargerData.special_rate ? `${chargerData.special_rate}%` : 'N/A'}</li>
                                <li><strong>County Tax Rate:</strong> {chargerData.county_rate ? `${chargerData.county_rate}%` : 'N/A'}</li>
                                <li><strong>City Tax Rate:</strong> {chargerData.city_rate ? `${chargerData.city_rate}%` : 'N/A'}</li>
                                <li><strong>Gas Tax Rate:</strong> {chargerData.gas_eqivalent_rate ? `${chargerData.gas_eqivalent_rate}%` : 'N/A'}</li>
                            </ul>
                        </div>
                    </Collapse>
                    <p><strong>Total Price per kWh:</strong> ${chargerData.price_per_kwh ? chargerData.price_per_kwh.toFixed(2) : 'N/A'}</p>
                    <p><strong>Payment Processing Fee:</strong> {chargerData.payment_processing_fee || '2.9% + $0.30'}</p>
                    <Form onSubmit={handleSubmit} className="mt-4">
                        <Form.Group>
                            <Form.Label>Card Details</Form.Label>
                            <CardElement options={{ hidePostalCode: true }} />
                        </Form.Group>
                        {error && <div className="text-danger mt-2">{error}</div>}
                        <Button type="submit" variant="primary" className="mt-3" disabled={loading}>
                            {loading ? 'Processing...' : 'Start Charging'}
                        </Button>
                        {isGuest && (
                          <div className="mt-3 text-warning">
                            <strong>Note:</strong> As a guest, you will not have access to session history or reporting.
                          </div>
                        )}
                    </Form>
                </Card>
            </Col>
        </Row>
      </Container>
    );
  }
};

export default CheckoutForm;
